import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { setToken } from '../../lib/session';

/**
 * Only rendered when VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY aren't set —
 * i.e. local development. Pastes the same bearer token `curl` would send;
 * this UI grants nothing a raw API call couldn't already do.
 */
export function DevTokenForm() {
  const { t } = useTranslation('auth');
  const [tokenInput, setTokenInput] = useState('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setToken(tokenInput.trim());
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="rounded-lg border border-signal/30 bg-signal/10 px-3 py-2 text-xs text-signal">
        {t('devToken.notConfigured')}
      </div>
      <label className="block text-sm font-semibold text-ink">
        {t('devToken.tokenLabel')}
        <textarea
          required
          dir="ltr"
          value={tokenInput}
          onChange={(e) => setTokenInput(e.target.value)}
          rows={4}
          className="mt-2 w-full rounded-lg border border-black/12 bg-white px-3 py-2 font-mono text-xs text-ink outline-none transition focus:border-signal/50 focus:ring-2 focus:ring-signal/20"
          placeholder="eyJhbGciOi..."
        />
      </label>
      <button
        type="submit"
        className="w-full rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition"
        style={{ backgroundColor: '#c45c26' }}
      >
        {t('devToken.continue')}
      </button>
    </form>
  );
}
